import { useEffect, useState } from "react";

/** Shows a banner when a newer build has been deployed while this tab was open. */
export function VersionWatcher() {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (import.meta.env.DEV) return;
    const check = async () => {
      try {
        const r = await fetch(`/version.txt?t=${Date.now()}`, { cache: "no-store" });
        const v = (await r.text()).trim();
        if (r.ok && v && !v.startsWith("<") && v !== __BUILD_ID__) setStale(true);
      } catch {
        /* offline: ignore */
      }
    };
    const id = setInterval(check, 5 * 60_000);
    const onFocus = () => void check();
    window.addEventListener("focus", onFocus);
    void check();
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
    };
  }, []);
  if (!stale) return null;
  return (
    <div role="status" className="no-print fixed left-1/2 top-3 z-[70] flex -translate-x-1/2 items-center gap-3 rounded-md bg-brand-600 px-4 py-2 text-sm text-white shadow-lg">
      A new version of the app is available.
      <button className="rounded bg-white px-2 py-0.5 font-medium text-brand-600" onClick={() => location.reload()}>
        Reload
      </button>
    </div>
  );
}
